import React, { useState } from "react"
import { withRouter } from "react-router-dom"
import "./Menu.css"
import logo from "./ytlogo.png"
import menuIcon from "./menu.png"

const Menu = (props) => {
  const [openMenu, setOpenMenu] = useState(false)

  const setClassNames = (num) => {
    const classArr = ["m-item"]
    if (openMenu) classArr.push(`open-${num}`)
    return classArr.join(" ")
  }

  const pushToRoute = (route) => {
    props.history.push(route)
    setOpenMenu(false)
  }

  return (
    <div className={`Menu ${openMenu ? "isOpen" : ""}`}>
      <div className={"m-item m-logo"} onClick={() => setOpenMenu(!openMenu)}>
        Menu{" "}
        <img
          src={menuIcon}
          style={{ marginLeft: "10px" }}
          alt=""
          height="30"
          width="30"
        />
      </div>

      <div className={setClassNames(1)} onClick={() => pushToRoute("/")}>
        Home
      </div>

      <div className={setClassNames(2)} onClick={() => pushToRoute("/about-us")}>
        About Us
      </div>

      <a
        className={setClassNames(3)}
        href="https://thebroadwaymaven.substack.com/"
        target="_blank"
        rel="noreferrer"
        style={{ fontStyle: "italic", textDecoration: "none" }}
      >
        MARQUEE
      </a>

      <a
        className={setClassNames(4)}
        href="https://www.youtube.com/c/DavidBenkofTheBroadwayMaven"
        rel="noreferrer"
        target="_blank"
        style={{ textDecoration: "none", color: "white" }}
      >
        <img src={logo} alt="YouTube" height="30" width="150" />
      </a>
    </div>
  )
}

export default withRouter(Menu)
